import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { SchoolTabs, CompanyTabsWrapper } from '../Tabs';
import profileTabsPropertyTypes from '../profileTabsPropertyTypes';

const profileAboutPropertyTypes = {
  profile: PropTypes.shape({
    type: PropTypes.oneOf(['SCHOOL', 'COMPANY'] as const).isRequired,
    page: PropTypes.shape({
      premium: PropTypes.bool,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    ...profileTabsPropertyTypes,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

type ProfileAboutProperties = InferProps<typeof profileAboutPropertyTypes>;

const ProfileAbout = ({
  children,
  profile,
}: ProfileAboutProperties) => {
  const {
    type, page: { premium },
  } = profile;

  return (
    <>
      {type === 'SCHOOL' && premium && <SchoolTabs profile={profile} />}
      {type === 'COMPANY' && <CompanyTabsWrapper profile={profile} />}
      {children}
    </>
  );
};

ProfileAbout.propTypes = profileAboutPropertyTypes;

export default ProfileAbout;
